'use client';

import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

interface KioskHeaderProps {
  currentTime: string;
  currentDate: string;
  isOnline: boolean;
  isAuthorized: boolean;
}

export default function KioskHeader({
  currentTime,
  currentDate,
  isOnline,
  isAuthorized,
}: KioskHeaderProps) {
  return (
    <header className="flex items-center justify-between px-10 py-6 border-b kiosk-border">
      {/* Branding */}
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-kiosk-blue flex items-center justify-center flex-shrink-0">
          <AppLogo size={32} className="brightness-200" />
        </div>
        <div>
          <div className="text-xl font-semibold kiosk-text tracking-tight">
            The English Island
          </div>
          <div className="text-sm kiosk-muted font-medium tracking-wide uppercase" style={{ letterSpacing: '0.08em' }}>
            Staff &amp; Faculty Time Clock
          </div>
        </div>
      </div>

      {/* Live Clock */}
      <div className="text-center">
        <div className="tabular-nums kiosk-text font-bold" style={{ fontSize: '3.5rem', lineHeight: 1, letterSpacing: '-0.02em' }}>
          {currentTime || '—'}
        </div>
        <div className="text-kiosk-blue text-base font-medium mt-1">
          {currentDate || '—'}
        </div>
      </div>

      {/* Status indicators */}
      <div className="flex flex-col items-end gap-2">
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${
          isOnline
            ? 'bg-blue-900 bg-opacity-20 text-blue-300 border border-blue-700 border-opacity-30' :'bg-red-900 bg-opacity-20 text-kiosk-red border border-red-700 border-opacity-30'
        }`}>
          <span className={`w-2 h-2 rounded-full ${isOnline ? 'bg-blue-400' : 'bg-red-400'} ${isOnline ? 'animate-pulse' : ''}`} />
          {isOnline ? 'Connected' : 'Offline'}
        </div>
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${
          isAuthorized
            ? 'bg-blue-900 bg-opacity-20 text-blue-300 border border-blue-700 border-opacity-30' :'bg-red-900 bg-opacity-20 text-kiosk-red border border-red-700 border-opacity-30'
        }`}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          {isAuthorized ? 'Authorized Kiosk' : 'Not Authorized'}
        </div>
      </div>
    </header>
  );
}